<ap-dropdown
  [list]="taxResultStatusItems()"
  [title]="'taxResult.taxResultStatus' | translate"
  selectType="single"
  [(ngModel)]="selected">
  @for (item of taxResultStatusItems(); track $index) {
    <ap-dropdown-list-item
      [item]="item"
      (onSelectItem)="onSelectFilterItem($event)">
    </ap-dropdown-list-item>
  }
</ap-dropdown>
